// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { BarsOutlined, CustomerServiceOutlined, QuestionCircleOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { BarsOutlined, CustomerServiceOutlined, QuestionCircleOutlined };

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support: NavItemType = {
  id: 'support-menu',
  type: 'group',
  children: [
    {
      id: 'support',
      title: <FormattedMessage id="support" />,
      type: 'collapse',
      icon: icons.QuestionCircleOutlined,
      defaultOpen: false,
      children: [
        {
          id: 'faqs',
          title: <FormattedMessage id="faqs" />,
          type: 'item',
          url: '/support/faqs',
          icon: icons.BarsOutlined
        },
        {
          id: 'help',
          title: <FormattedMessage id="help" />,
          type: 'item',
          url: '/support/help',
          icon: icons.CustomerServiceOutlined
        }
      ]
    }
  ]
};

export default support;
